/**
 * @owner @Appboy/intelligence
 */

import type { AgentPreviewAsyncResult, CampaignQaRuleResult, GenerativeAiCampaignQaPreviewResult } from "./types";

/**
 * Normalizes a raw async agent-preview result into the QA preview shape consumed by
 * the Campaign QA and Canvas QA preview hooks. Scope-agnostic — the QA result rows
 * are the same shape regardless of which QA agent produced them.
 */
export function mapAsyncResultToQaPreviewResult(
  asyncResult: AgentPreviewAsyncResult
): GenerativeAiCampaignQaPreviewResult {
  return {
    result: asyncResult.result ?? null,
    execution_time_ms: asyncResult.execution_time_ms ?? 0,
    errors: asyncResult.errors ?? null,
    tool_execution_logs: asyncResult.tool_execution_logs,
    execution_usage: asyncResult.execution_usage,
    qa_results: asyncResult.qa_results as CampaignQaRuleResult[] | undefined,
  };
}
